import React from "react";
import { useTranslation } from "react-i18next";
import BaseTextArea from "../../components/BaseTextArea";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import WrapperPage from "../../components/WrapperPage";
import Butterflies from "../../components/Butterflies";
import Ellipses from "../../components/Ellipses";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import FeedbackModal from "../../modals/FeedbackModal";
import ROUTES from "../../utils/routes.js";

export default function FeedbackPage() {
  const { onSubmitHandle, isFeedbackLoading, isError } = useController();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="feedback-container">
      <FeedbackModal />
      <Butterflies className="feedback-butterflies" countEllipses={1} />
      <Ellipses countEllipses={1} className="feedback-ellipses" />
      <Butterflies className="feedback-butterflies" countEllipses={2} />
      <Ellipses countEllipses={2} className="feedback-ellipses" />
      <WrapperPage
        onClickBackBtn={() => navigate(ROUTES.PERSONAL_ACCOUNT_PAGE)}
        backBtn
        burgerMenu
      >
        <div
          className="feedback-container__title neon-text"
          data-text={t("feedback.title")}
        >
          {t("feedback.title")}
        </div>
        <div className="feedback-container__wrapper">
          <div className="feedback-container__desc">
            <p>{t("feedback.desc1")}</p>
            <p>{t("feedback.desc2")}</p>
            <p>{t("feedback.desc3")}</p>
          </div>
          <div className="feedback-container__form-wrap">
            <div
              className="feedback-container__form-wrap--title neon-text"
              data-text={t("feedback.title-form")}
            >
              {t("feedback.title-form")}
            </div>
            <div className="feedback-container__form-wrap--desc">
              {t("feedback.desc-form")}
            </div>
            <form
              onSubmit={onSubmitHandle}
              className="feedback-container__form"
            >
              <div className="feedback-container__form__field">
                <div className="feedback-container__form--label">
                  <span>1.</span>{t("feedback.label1")}
                </div>
                <BaseTextArea
                  name="text1"
                  className="feedback-container__form--textarea"
                  placeholder={t("feedback.placeholder")}
                  onChange={() => {}}
                />
              </div>
              <div className="feedback-container__form__field">
                <div className="feedback-container__form--label">
                  <span>2.</span>{t("feedback.label2")}
                </div>
                <BaseTextArea
                  name="text2"
                  className="feedback-container__form--textarea"
                  placeholder={t("feedback.placeholder")}
                  onChange={() => {}}
                />
              </div>
              <div className="feedback-container__form__field">
                <div className="feedback-container__form--label">
                  <span>3.</span>{t("feedback.label3")}
                </div>
                <BaseTextArea
                  name="text3"
                  className="feedback-container__form--textarea"
                  placeholder={t("feedback.placeholder")}
                  onChange={() => {}}
                />
              </div>
              <BaseButton
                loading={isFeedbackLoading}
                type="submit"
                className="feedback-container__form__submit"
              >
                {t("send")}
              </BaseButton>
              {isError && <div className="feedback-container__form__error">{t('fill_the_fields')}</div>}
            </form>
          </div>
        </div>
      </WrapperPage>
    </div>
  );
}
